import React from 'react';
import { Platform } from 'react-native';
import {
  Box, HStack, Icon, Text, VStack,
} from '@gluestack-ui/themed';
import { Monitor } from 'lucide-react-native';
import { useTranslation } from 'react-i18next';

/**
 * Oral exams require a live camera/microphone capture flow that is only
 * implemented for the web build (see `IdVerificationStep`, `LecturerPresenceSetup`,
 * and the LiveKit meeting components — all hardwired to the web platform since
 * that is the only place a lecturer proctors from a full computer). The native
 * app has no working join path for this task type, so tell the student up
 * front rather than letting them discover it mid-flow.
 */
export function OralExamMobileAppNotice() {
  const { t } = useTranslation();
  if (Platform.OS === 'web') return null;

  return (
    <Box
      bg="$bgBrandSubtle"
      borderWidth={1}
      borderColor="$borderBrand"
      borderRadius="$md"
      p="$4"
      testID="oral-exam-mobile-app-notice"
    >
      <HStack space="sm" alignItems="flex-start">
        <Icon as={Monitor} size="md" color="$brandBase" mt="$1" />
        <VStack space="xs" flex={1}>
          <Text size="md" fontWeight="semibold" color="$textHeading">
            {t('oralExam.mobileAppNotice.title', { defaultValue: 'Join this exam from a computer' })}
          </Text>
          <Text size="sm" color="$textBody">
            {t('oralExam.mobileAppNotice.body', {
              defaultValue: 'Oral exams use live camera and microphone sharing that is only supported in a web browser. Please open this task on a computer using Chrome, Safari, or Firefox — the app cannot be used to join.',
            })}
          </Text>
        </VStack>
      </HStack>
    </Box>
  );
}
